import {http} from "Services/Http/HttpClient";

export interface Cart {
    id: string;
    tutor: {
        id: string;
        name: string;
    };
    totalPrice: number;
    status: number;
    items: CartItem[]
}

export interface CartItemService {
    id: string;
    name: string;
    price: number;
}

export interface CartItem {
    id: string,
    child: {
        id: string;
        name: string;
        surnames: string;
    };
    activitySession: {
        id: string;
        name: string;
        image: string;
    };
    price: number;
    services: CartItemService[];
    days: Array<{
        id: string;
        name: string;
        price: number;
    }>;
    description: string;
    start: string;
    end: string;
    billable: boolean;
    numberOfDays: number;
    courseLevel: {
        id: string;
        name: string;
    },
    center: {
        id: string;
        name: string;
    },
    totalPrice: number,
    image: string | null,
    initDate: string,
    name: string,
    activity?: {
        id: string;
        name: string;
        canSelectMultipleYearDays: boolean;
        paymentType?: {
            id: string;
            name: string;
        };
    },
    observations: string|null,
    discountAmount: number,
    totalPriceWithDiscount: number,
    discount?: {
        id: string,
        name: string,
        value: number,
    }
    extraDiscount?: {
        id: string,
        name: string,
        value: number,
        amount: number,
    },
    enrollment?: {
        formattedPrice: string
        id: string
        name:string,
        price:number
    }
}


export const getCart = async (): Promise<Cart> => {
    return await http.get('cart')
}

export interface CartPaymentRequirements {
    requires_credit_card: boolean;
    requires_iban: boolean;
    tutor_has_credit_card: boolean;
    tutor_has_iban: boolean;
}

export const getCartPaymentRequirements = async (): Promise<CartPaymentRequirements> => {
    return await http.get('cart/payment-requirements')
}
